import script from "./MotivoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MotivoModal.vue?vue&type=script&setup=true&lang=js"

import "./MotivoModal.vue?vue&type=style&index=0&id=7ccdb62e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ccdb62e"]])

export default __exports__